import { dbTableTraffic } from "@dataseat-dsp-client/lib-reporter";

export const convertNormalizedToBucketBidFloor =
  dbTableTraffic.convertNormalizedToBucketBidFloor;
export const convertBucketBidFloor = dbTableTraffic.convertBucketBidFloor;
